module.exports = __webpack_public_path__ + "img/qy4.70a6e144.jpg";